/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnQrRedeemBody
 */
export interface EarnQrRedeemBody {
    /**
     * 
     * @type {string}
     * @memberof EarnQrRedeemBody
     */
    token: string;
}

/**
 * Check if a given object implements the EarnQrRedeemBody interface.
 */
export function instanceOfEarnQrRedeemBody(value: object): value is EarnQrRedeemBody {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function EarnQrRedeemBodyFromJSON(json: any): EarnQrRedeemBody {
    return EarnQrRedeemBodyFromJSONTyped(json, false);
}

export function EarnQrRedeemBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnQrRedeemBody {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function EarnQrRedeemBodyToJSON(json: any): EarnQrRedeemBody {
    return EarnQrRedeemBodyToJSONTyped(json, false);
}

export function EarnQrRedeemBodyToJSONTyped(value?: EarnQrRedeemBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

